export default {"src":"/_next/static/media/germanDocument_24.d6c8e8c0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};